window.onload = function() {

  
  
  var sections = document.querySelectorAll('.logo-bar .product-grid');
  sections.forEach((elem) => {
    elem.style.display = "block";
  	new Flickity(elem, {
        /*wrapAround: true,*/
        prevNextButtons: true,
      contain: true,
      groupCells: true,
      cellAlign: 'left',
      pageDots: false
      });
      
  });

  
  
  var tab_sections = document.querySelectorAll('.widget-tabs');
tab_sections.forEach((tabs) => {
  let headerTabs = tabs.querySelectorAll('.widget-tabs__header > li');
  let contentTabs = tabs.querySelectorAll('.widget-tabs__tab');
  
  headerTabs.forEach((title, i) => {
    title.onclick = () => {
      contentTabs.forEach((content, j) => {
      	content.classList.remove('open');
        headerTabs[j].classList.remove('open');
        if(i == j) {
          headerTabs[j].classList.add('open');
          content.classList.add('open');
        }
      });
    }
  });
  
  if (!tabs.querySelector('.open')) {
    headerTabs[0].classList.add('open');
    contentTabs[0].classList.add('open');
  }
});

  
var zipcodes = [{"zip":"33015","day": theme.strings.deliveryMonday},
                {"zip":"33018","day": theme.strings.deliveryMonday},
                {"zip":"33014","day": theme.strings.deliveryMonday},
                {"zip":"33012","day": theme.strings.deliveryMonday},
                {"zip":"33013","day": theme.strings.deliveryMonday},
                {"zip":"33010","day": theme.strings.deliveryMonday},
                {"zip":"33166","day": theme.strings.deliveryMonday},
                {"zip":"33178","day": theme.strings.deliveryMonday},
                {"zip":"33192","day":theme.strings.deliveryMonday},
                {"zip":"33182","day":theme.strings.deliveryMonday},
                {"zip":"33172","day":theme.strings.deliveryMonday},
                {"zip":"33122","day":theme.strings.deliveryMonday},
                {"zip":"33126","day":theme.strings.deliveryMonday},
                {"zip":"33144","day":theme.strings.deliveryMonday},
                {"zip":"33174","day":theme.strings.deliveryMonday},
                {"zip":"33184","day":theme.strings.deliveryMonday},
                {"zip":"33194","day":theme.strings.deliveryMonday},
                {"zip":"33185","day":theme.strings.deliveryMonday},
                {"zip":"33175","day":theme.strings.deliveryMonday},
                {"zip":"33165","day":theme.strings.deliveryMonday},
                {"zip":"33016","day":theme.strings.deliveryMonday},
                {"zip":"33195","day":theme.strings.deliveryMonday},
                {"zip":"33199","day":theme.strings.deliveryMonday},
                {"zip":"33142","day":theme.strings.deliveryTuesday},
                {"zip":"33127","day":theme.strings.deliveryTuesday},
                {"zip":"33137","day":theme.strings.deliveryTuesday},
                {"zip":"33125","day":theme.strings.deliveryTuesday},
                {"zip":"33136","day":theme.strings.deliveryTuesday},
                {"zip":"33132","day":theme.strings.deliveryTuesday},
                {"zip":"33128","day":theme.strings.deliveryTuesday},
                {"zip":"33134","day":theme.strings.deliveryTuesday},
                {"zip":"33135","day":theme.strings.deliveryTuesday},
                {"zip":"33130","day":theme.strings.deliveryTuesday},
                {"zip":"33131","day":theme.strings.deliveryTuesday},
                {"zip":"33145","day":theme.strings.deliveryTuesday},
                {"zip":"33129","day":theme.strings.deliveryTuesday},
                {"zip":"33149","day":theme.strings.deliveryTuesday},
                {"zip":"33155","day":theme.strings.deliveryTuesday},
                {"zip":"33143","day":theme.strings.deliveryTuesday},
                {"zip":"33146","day":theme.strings.deliveryTuesday},
                {"zip":"33133","day":theme.strings.deliveryTuesday},
                {"zip":"33193","day":theme.strings.deliveryMonday},
                {"zip":"33183","day":theme.strings.deliveryMonday},
                {"zip":"33173","day":theme.strings.deliveryMonday},
                {"zip":"33196","day":theme.strings.deliveryMonday},
                {"zip":"33186","day":theme.strings.deliveryMonday},
                {"zip":"33176","day":theme.strings.deliveryTuesday},
                {"zip":"33156","day":theme.strings.deliveryTuesday},
                {"zip":"33158","day":theme.strings.deliveryTuesday},
                {"zip":"33187","day":theme.strings.deliveryMonday},
                {"zip":"33177","day":theme.strings.deliveryMonday},
                {"zip":"33157","day":theme.strings.deliveryMonday},
                {"zip":"33109","day":theme.strings.deliveryTuesday},
                {"zip":"33428","day":theme.strings.deliveryWednesday},
                {"zip":"33433","day":theme.strings.deliveryWednesday},
                {"zip":"33486","day":theme.strings.deliveryWednesday},
                {"zip":"33432","day":theme.strings.deliveryWednesday},
                {"zip":"33076","day":theme.strings.deliveryWednesday},
                {"zip":"33067","day":theme.strings.deliveryWednesday},
                {"zip":"33073","day":theme.strings.deliveryWednesday},
                {"zip":"33442","day":theme.strings.deliveryWednesday},
                {"zip":"33441","day":theme.strings.deliveryWednesday},
                {"zip":"33065","day":theme.strings.deliveryWednesday},
                {"zip":"33064","day":theme.strings.deliveryWednesday},
                {"zip":"33071","day":theme.strings.deliveryWednesday},
                {"zip":"33063","day":theme.strings.deliveryWednesday},
                {"zip":"33066","day":theme.strings.deliveryWednesday},
                {"zip":"33069","day":theme.strings.deliveryWednesday},
                {"zip":"33060","day":theme.strings.deliveryWednesday},
                {"zip":"33062","day":theme.strings.deliveryWednesday},
                {"zip":"33321","day":theme.strings.deliveryWednesday},
                {"zip":"33068","day":theme.strings.deliveryWednesday},
                {"zip":"33309","day":theme.strings.deliveryWednesday},
                {"zip":"33334","day":theme.strings.deliveryWednesday},
                {"zip":"33308","day":theme.strings.deliveryWednesday},
                {"zip":"33306","day":theme.strings.deliveryWednesday},
                {"zip":"33305","day":theme.strings.deliveryWednesday},
                {"zip":"33304","day":theme.strings.deliveryWednesday},
                {"zip":"33311","day":theme.strings.deliveryWednesday},
                {"zip":"33316","day":theme.strings.deliveryWednesday},
                {"zip":"33315","day":theme.strings.deliveryWednesday},
                {"zip":"33312","day":theme.strings.deliveryWednesday},
                {"zip":"33004","day":theme.strings.deliveryWednesday},
                {"zip":"33019","day":theme.strings.deliveryThursday},
                {"zip":"33020","day":theme.strings.deliveryWednesday},
                {"zip":"33021","day":theme.strings.deliveryWednesday},
                {"zip":"33301","day":theme.strings.deliveryWednesday},
                {"zip":"33302","day":theme.strings.deliveryWednesday},
                {"zip":"33310","day":theme.strings.deliveryWednesday},
                {"zip":"33335","day":theme.strings.deliveryWednesday},
                {"zip":"33338","day":theme.strings.deliveryWednesday},
                {"zip":"33394","day":theme.strings.deliveryWednesday},
                {"zip":"33009","day":theme.strings.deliveryThursday},
                {"zip":"33167","day":theme.strings.deliveryThursday},
                {"zip":"33168","day":theme.strings.deliveryThursday},
                {"zip":"33169","day":theme.strings.deliveryThursday},
                {"zip":"33179","day":theme.strings.deliveryThursday},
                {"zip":"33180","day":theme.strings.deliveryThursday},
                {"zip":"33160","day":theme.strings.deliveryThursday},
                {"zip":"33162","day":theme.strings.deliveryThursday},
                {"zip":"33055","day":theme.strings.deliveryThursday},
                {"zip":"33056","day":theme.strings.deliveryThursday},
                {"zip":"33054","day":theme.strings.deliveryThursday},
                {"zip":"33161","day":theme.strings.deliveryThursday},
                {"zip":"33181","day":theme.strings.deliveryThursday},
                {"zip":"33154","day":theme.strings.deliveryThursday},
                {"zip":"33314","day":theme.strings.deliveryFriday},
                {"zip":"33029","day":theme.strings.deliveryFriday},
                {"zip":"33028","day":theme.strings.deliveryFriday},
                {"zip":"33147","day":theme.strings.deliveryThursday},
                {"zip":"33150","day":theme.strings.deliveryThursday},
                {"zip":"33138","day":theme.strings.deliveryThursday},
                {"zip":"33141","day":theme.strings.deliveryThursday},
                {"zip":"33140","day":theme.strings.deliveryThursday},{"zip":"33139","day":theme.strings.deliveryThursday},{"zip":"33008","day":theme.strings.deliveryThursday},{"zip":"33327","day":theme.strings.deliveryFriday},{"zip":"33326","day":theme.strings.deliveryFriday},{"zip":"33325","day":theme.strings.deliveryFriday},{"zip":"33324","day":theme.strings.deliveryFriday},{"zip":"33323","day":theme.strings.deliveryFriday},{"zip":"33322","day":theme.strings.deliveryFriday},{"zip":"33351","day":theme.strings.deliveryFriday},{"zip":"33319","day":theme.strings.deliveryFriday},{"zip":"33313","day":theme.strings.deliveryFriday},{"zip":"33317","day":theme.strings.deliveryFriday},{"zip":"33332","day":theme.strings.deliveryFriday},{"zip":"33331","day":theme.strings.deliveryFriday},{"zip":"33330","day":theme.strings.deliveryFriday},{"zip":"33328","day":theme.strings.deliveryFriday},{"zip":"33026","day":theme.strings.deliveryFriday},{"zip":"33024","day":theme.strings.deliveryFriday},{"zip":"33027","day":theme.strings.deliveryFriday},{"zip":"33025","day":theme.strings.deliveryFriday},{"zip":"33023","day":theme.strings.deliveryFriday},{"zip":"33022","day":theme.strings.deliveryWednesday},{"zip":"33318","day":theme.strings.deliveryFriday},{"zip":"33329","day":theme.strings.deliveryFriday},{"zip":"33336","day":theme.strings.deliveryFriday},{"zip":"33388","day":theme.strings.deliveryFriday},{"zip":"33414","day":theme.strings.deliveryWednesday},{"zip":"33413","day":theme.strings.deliveryWednesday},{"zip":"33415","day":theme.strings.deliveryWednesday},{"zip":"33406","day":theme.strings.deliveryWednesday},{"zip":"33405","day":theme.strings.deliveryWednesday},{"zip":"33461","day":theme.strings.deliveryWednesday},{"zip":"33460","day":theme.strings.deliveryWednesday},{"zip":"33446","day":theme.strings.deliveryWednesday},{"zip":"33456","day":theme.strings.deliveryWednesday},{"zip":"33458","day":theme.strings.deliveryWednesday},{"zip":"33478","day":theme.strings.deliveryWednesday},{"zip":"33418","day":theme.strings.deliveryWednesday},{"zip":"33477","day":theme.strings.deliveryWednesday},{"zip":"33410","day":theme.strings.deliveryWednesday},{"zip":"33408","day":theme.strings.deliveryWednesday},{"zip":"33403","day":theme.strings.deliveryWednesday},{"zip":"33404","day":theme.strings.deliveryWednesday},{"zip":"33412","day":theme.strings.deliveryWednesday},{"zip":"33470","day":theme.strings.deliveryWednesday},{"zip":"33411","day":theme.strings.deliveryWednesday},{"zip":"33417","day":theme.strings.deliveryWednesday},{"zip":"33409","day":theme.strings.deliveryWednesday},{"zip":"33401","day":theme.strings.deliveryWednesday},{"zip":"33480","day":theme.strings.deliveryWednesday},{"zip":"33452","day":theme.strings.deliveryWednesday},{"zip":"33496","day":theme.strings.deliveryWednesday},{"zip":"33487","day":theme.strings.deliveryWednesday},{"zip":"33498","day":theme.strings.deliveryWednesday},{"zip":"33434","day":theme.strings.deliveryWednesday},{"zip":"33431","day":theme.strings.deliveryWednesday},{"zip":"33463","day":theme.strings.deliveryWednesday},{"zip":"33467","day":theme.strings.deliveryWednesday},{"zip":"33449","day":theme.strings.deliveryWednesday},{"zip":"33472","day":theme.strings.deliveryWednesday},{"zip":"33462","day":theme.strings.deliveryWednesday},{"zip":"33435","day":theme.strings.deliveryWednesday},{"zip":"33426","day":theme.strings.deliveryWednesday},{"zip":"33484","day":theme.strings.deliveryWednesday},{"zip":"33445","day":theme.strings.deliveryWednesday},{"zip":"33444","day":theme.strings.deliveryWednesday},{"zip":"33483","day":theme.strings.deliveryWednesday},{"zip":"33436","day":theme.strings.deliveryWednesday},{"zip":"33437","day":theme.strings.deliveryWednesday},{"zip":"33473","day":theme.strings.deliveryWednesday}];
  
var btnFind = document.querySelector('.btn-find');
if(btnFind) {
  btnFind.addEventListener('click', function(e){
    var input = document.getElementById('zipcode');
    var obj = zipcodes.find(zip => zip.zip === input.value);
    var message = theme.strings.zipNoResults;
    if(obj) {
      var day = obj.day;
      message =  '<span class="text-uppercase">' + day + '</span>. ' + theme.strings.cartInclude + ' <span class="text-uppercase">' + day + '</span> ' + theme.strings.deliveryDate;
    } 
    document.querySelector('.message').innerHTML = message;
  });
}



  
};

